import { Attachement } from "./Attachement";
import { Article } from "./Product";

export interface IReturn {
  numTournee: number;
  statutId: number;
  statutName: string;
  statutBackground: string;
  statutTextcolour: string;
  sellerId: string;
  sellerName: string;
  createdon: string;
  countArticles: number;
  entityId: number | null;
  entityName: string | null;
  isSellerVIP: boolean;
  isSpecialSeller?: boolean;
  sellerReceptionPartial?: boolean;
  urlPathReceptionPartial?: string;
  url?: string; // Update the type of articles as needed
  perRequest?: boolean;
  sourceVendable?: string;
  numPOScale?: string | null;
  numCDA?: string | null;
  urlCachte?: string;
  islitige: boolean;
  articles: Article[];
  colis: Colis[];
  numDemande?: number;
  typeTournee?: ReturnTypesEnum;
}

export enum ReturnTypesEnum {
  RTO_EMM = "EMM RTO",
  RTO_HUB = "HUB RTO",
  STANDARD = "STANDARD",
}

export interface ReturnToCreate {
  numTournee: string;
  articles: ArticleToCreate[];
  isSellerVIP: boolean;
  entityId: number | null;
  sellerId: string;
}

export interface ReturnToCreateViaRequest {
  numTournee: string;
  isSellerVIP: boolean;
  entityId: number | null;
  sellerId: string;
  sourceId: number;
  demandes: ReturnRequest_[];
}

export interface ReturnRequest_ {
  headerid: number;
  sellerId: string;
}

export interface ReturnToCreate_ {
  numTournee: string;
  articles: ArticleToCreate[];
  sellerId: string;
  blCachet: Attachement;
}

export interface ArticleToCreate {
  productId: string;
  quantity: number;
  numSerie: string;
}

export interface DraftReturn {
  validProducts: Article[];
  returnNumber: string;
  seller: string;
  products: Article[];
  roles: string;
  notes: string;
  screen: string;
}
export interface ReturnRequest {
  num: number;
  createdon: string;
  countProducts: number;
  colis: Colis[];
}

export interface Colis {
  colisId: number;
  colisCode: string;
  qte: number;
  sum_qte: number;
  articles: Article[];
}

export interface ValidationData {
  articles: ArticleToCreate[];
  numTournee: string;
}
export interface ReturnToCreateViaRequest_ {
  numTournee: string;
  isSellerVIP: boolean;
  entityId: number | null;
  sellerId: string;
  demandes: { headerId: number }[];
  products: { productId: string; qteEntrepote: number }[];
}

export interface ReturnList {
  list: IReturn[];
  count_pages: number;
  page_number: number;
}

export interface ColisPayload {
  colisId: number;
  colisCode: string;
  products: ProductPayload[];
}

export interface ProductPayload {
  productId: string;
  ean: string;
  qte: number;
}

export interface CanceledReturnReceptionPayload {
  numTournee: string;
  colis: ColisPayload[];
}

export interface Status {
  id: number;
  name: string;
}

export interface RtoBulkScanReturn {
  numTournee: number;
  sellerId: string;
  sellerName: string;
  entityId: number | null;
  entityName: string | null;
  statutId?: number;
  statutName?: string;
  countArticles?: number;
  numDemande?: number;
  typeTournee?: string;
  colis: Colis[];
}

export interface RtoBulkScanData {
  operationId: number;
  list: RtoBulkScanReturn[];
}

export interface RtoBulkScannedColisItem {
  numTournee: number;
  sellerId: string;
  colisCode: string;
}

export interface RtoBulkValidationPayload {
  operationId: number;
  colis: RtoBulkScannedColisItem[];
}
